import React from 'react';

/**
 * Shared tooltip components for Recharts across all dashboards
 */

export const PieTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const d = payload[0];
  return (
    <div className="recharts-custom-tooltip">
      <span className="legend-dot" style={{ backgroundColor: d.payload.fill }} />
      <strong>{d.name}</strong>: {d.value.toLocaleString()}
    </div>
  );
};

export const BarTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="recharts-custom-tooltip">
      <strong>{label}</strong>: {payload[0].value} drawings
    </div>
  );
};
